<template>
  <div class="external-banner" v-if="externalCloudCases">
    <v-container class="pr-12">
      <v-row>
        <v-col cols="12" sm="5" offset-sm="4" class="pl-12 pb-1 pt-2">
          {{ $t('dealer.loggedIntoCustomer') }}
        </v-col>
        <v-col cols="12" sm="3" class="py-1">
          <v-btn
            light
            class="font-weight-bold"
            style="float: right"
            @click="backToExternal"
            data-testid="dealer-banner-back-to-external"
          >
            {{ backToExternalTitle }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'ExternalBanner',
  computed: {
    ...mapState('Security', ['isTokenAuthenticated', 'externalSystemName']),
    externalCloudCases() {
      return this.isTokenAuthenticated
    },
    backToExternalTitle() {
      return this.externalSystemName
        ? `${this.$t('dealer.backTo')} ${this.externalSystemName}`
        : this.$t('dealer.backToExternalPortal')
    },
  },
  methods: {
    backToExternal() {
      const externalUrl = localStorage.getItem('externalUrl')
      if (externalUrl) {
        window.location.href = externalUrl
      }
    },
  },
})
</script>

<style lang="scss">
.external-banner {
  background-color: $color-secondary;
}
</style>
